// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.sidebar {
    background-color: #172639;
    position: fixed;
    top: 0px;
    left: 0px;
    width: 250px;
    font-family: "Poppins", sans-serif !important;
    font-weight: 400;
    overflow-y: auto;
    font-style: normal;
    font-size: 14px;
    /* box-shadow: 0 3px 5px -1px #0003, 0 6px 10px #00000024, 0 1px 18px #0000001f; */
    transition: width 0.5s;
    /* background-image: linear-gradient(to bottom right, #172639,#0003); */
}

.sidebar-scroll {
    overflow-y: auto;
    height: calc(100vh - 40px);
    padding-bottom: 1rem;
    border: #172639;
  }
  /* .sidebar-scroll::-webkit-scrollbar {
    width: 8px;
  } */
  
  .sidebar-scroll::-webkit-scrollbar {
    width: 10px;
  }
  
  .sidebar-scroll::-webkit-scrollbar-track {
    background: #172639;
    /* border-left: 1px solid #eaa637; */
    /* border-radius: 4px; */
  }
  
  .sidebar-scroll::-webkit-scrollbar-thumb {
    background-color: #eaa637;
    /* border: 1px solid #ffffff;  */
    border-radius: 4px;
  }
  

.cust-bg {
   
    border: none !important;
    border-radius: 0 !important;
}

.cust-item {  
    background-color: var(--secondary-color);
    color: var(--primary-color); 
    border: none !important;  
    /* margin: 4px 0px; */
}

.cust-item a{
    color: var(--primary-color);
}

.cust-item.active {
    /* background-color:var(--primary-color);
    color: white; */
    background-color: #f0f0f0;
    color: var(--secondary-color);
}


.cust-item.active a{
    /* background-color: var(--primary-color);
    color: white; */
    background-color: #f0f0f0;
    color: var(--secondary-color);
}

.cust-item:hover {
    /* background-color: var(--primary-color);
    color:white; */
    background-color: #f0f0f0;
    color: var(--secondary-color);
}

.cust-item:hover a{
    /* background-color: var(--primary-color);
    color:white; */
    background-color: #f0f0f0;
    color: var(--secondary-color);
}
.sidebar-h2 {
    /* color: var(--primary-color); */
    color: #f0f0f0;
    border-bottom: 1px solid var(--primary-color);
    font-size: 20px;
    height: 60px;
    margin: 0;
    transition-delay: 0.5s;
}



.title-div {
    height: 60px;
    border-bottom: 1px solid var(--primary-color);
   
}

.bank-sidebar .nav-link {
   
    margin-left: 10px;
}




.nav-item .nav-link {
    text-align: left;
    border: none;
    background: none;
}



.top-bar {
    height: 60px;
    width: 100%;
    position: fixed;
    top: 0;
    margin-left: 250px;
}
.mainn-content {   
     margin-left: 250px;
     margin-top: 60px; /* Push content below the Topbar */
     height: calc(100vh - 60px); /* Full height minus Topbar */
     overflow-y: auto; /* Enable scrolling for main content */
     padding: 20px;
     transition: margin-left 0.3s ease; /* Smooth transition for sidebar collapse */    
}



.cust-row {
    height: 60px;
}

.top-bar h3 {
    color: var(--secondary-color);
    font-weight: bold;
}

.vr {
    height: 100%;
}

.main-content {
    margin-top: 60px;
    margin-left: 250px;
}


/* to set setting in the bottom of sidebar */
.bottom-div {
    position: absolute;
    bottom: 0;
    margin-bottom: 30px;
}



.roboto-thin {
    font-family: "Roboto", sans-serif;
    font-weight: 100;
    font-style: normal;
}

.roboto-light {
    font-family: "Roboto", sans-serif;
    font-weight: 300;
    font-style: normal;
}

.roboto-regular {
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    font-style: normal;
}

.roboto-medium {
    font-family: "Roboto", sans-serif;
    font-weight: 500;
    font-style: normal;
}

.roboto-bold {
    font-family: "Roboto", sans-serif;
    font-weight: 700;
    font-style: normal;
}

.roboto-black {
    font-family: "Roboto", sans-serif;
    font-weight: 900;
    font-style: normal;
}

.roboto-thin-italic {
    font-family: "Roboto", sans-serif;
    font-weight: 100;
    font-style: italic;
}

.roboto-light-italic {
    font-family: "Roboto", sans-serif;
    font-weight: 300;
    font-style: italic;
}

.roboto-regular-italic {
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    font-style: italic;
}

.roboto-medium-italic {
    font-family: "Roboto", sans-serif;
    font-weight: 500;
    font-style: italic;
}

.roboto-bold-italic {
    font-family: "Roboto", sans-serif;
    font-weight: 700;
    font-style: italic;
}

.roboto-black-italic {
    font-family: "Roboto", sans-serif;
    font-weight: 900;
    font-style: italic;
}



.toggle-button {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 1000;    
    cursor: pointer;
    background-color: var(--secondary-color);
    border-radius: 5px;
    border: none;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2); /* Shadow effect */
    transition: box-shadow 0.3s ease, transform 0.3s ease;
  }

  .toggle-button div{
    width: 20px;
    height: 2px;
    /* background-color: var(--primary-color); */
    background-color: #f0f0f0;
    margin: 6px 0;
  }

  .toggle-button:hover {
     box-shadow: 0px 6px 8px rgba(252, 252, 252, 0.2);
    transform: translateY(-2px);
  }
  
  .toggle-button:active {
    box-shadow: 0px 2px 4px rgba(252, 252, 252, 0.2);
    transform: translateY(1px); 
    
  }

.sidebar-option{  
   
   transition-delay: 0.3;
}



  .sideCollapse.sidebar
  {   
    width: 60px;
  }
  .sideCollapse span.sidebar-option{ 
    width: 0px;
    display: none;

}
.sideCollapse.top-bar
{   
  margin-left: 60px;
}

.sideCollapse.mainn-content
{   
  margin-left: 60px;
}
.cursorPointer{
    cursor: pointer;
}
/* ------------------------------------------media query--------------------------------------------- */

@media screen and (max-width:768px)  
{
    
   
}

@media screen and (min-width:768px)  
{
    
}`, "",{"version":3,"sources":["webpack://./src/components/Sidebar.css"],"names":[],"mappings":";AAKA;IACI,yBAAyB;IACzB,eAAe;IACf,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,6CAA6C;IAC7C,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,kFAAkF;IAClF,sBAAsB;IACtB,uEAAuE;AAC3E;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,oBAAoB;IACpB,eAAe;EACjB;EACA;;KAEG;;EAEH;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,oCAAoC;IACpC,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,gCAAgC;IAChC,kBAAkB;EACpB;;;AAGF;;IAEI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,wCAAwC;IACxC,2BAA2B;IAC3B,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI;mBACe;IACf,yBAAyB;IACzB,6BAA6B;AACjC;;;AAGA;IACI;mBACe;IACf,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI;kBACc;IACd,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI;kBACc;IACd,yBAAyB;IACzB,6BAA6B;AACjC;AACA;IACI,iCAAiC;IACjC,cAAc;IACd,6CAA6C;IAC7C,eAAe;IACf,YAAY;IACZ,SAAS;IACT,sBAAsB;AAC1B;;;;AAIA;IACI,YAAY;IACZ,6CAA6C;;AAEjD;;AAEA;;IAEI,iBAAiB;AACrB;;;;;AAKA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;;;;AAIA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,MAAM;IACN,kBAAkB;AACtB;AACA;KACK,kBAAkB;KAClB,gBAAgB,EAAE,kCAAkC;KACpD,0BAA0B,EAAE,6BAA6B;KACzD,gBAAgB,EAAE,sCAAsC;KACxD,aAAa;KACb,iCAAiC,EAAE,2CAA2C;AACnF;;;;AAIA;IACI,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;;AAGA,4CAA4C;AAC5C;IACI,kBAAkB;IAClB,SAAS;IACT,mBAAmB;AACvB;;;;AAIA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;AACtB;;;;AAIA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,aAAa;IACb,eAAe;IACf,wCAAwC;IACxC,kBAAkB;IAClB,YAAY;IACZ,0CAA0C,EAAE,kBAAkB;IAC9D,qDAAqD;EACvD;;EAEA;IACE,WAAW;IACX,WAAW;IACX,4CAA4C;IAC5C,yBAAyB;IACzB,aAAa;EACf;;EAEA;KACG,gDAAgD;IACjD,2BAA2B;EAC7B;;EAEA;IACE,gDAAgD;IAChD,0BAA0B;;EAE5B;;AAEF;;GAEG,qBAAqB;AACxB;;;;EAIE;;IAEE,WAAW;EACb;EACA;IACE,UAAU;IACV,aAAa;;AAEjB;AACA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;AACnB;AACA;IACI,eAAe;AACnB;AACA,uGAAuG;;AAEvG;;;;AAIA;;AAEA;;;AAGA","sourcesContent":["\n@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\n\n\n\n.sidebar {\n    background-color: #172639;\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    width: 250px;\n    font-family: \"Poppins\", sans-serif !important;\n    font-weight: 400;\n    overflow-y: auto;\n    font-style: normal;\n    font-size: 14px;\n    /* box-shadow: 0 3px 5px -1px #0003, 0 6px 10px #00000024, 0 1px 18px #0000001f; */\n    transition: width 0.5s;\n    /* background-image: linear-gradient(to bottom right, #172639,#0003); */\n}\n\n.sidebar-scroll {\n    overflow-y: auto;\n    height: calc(100vh - 40px);\n    padding-bottom: 1rem;\n    border: #172639;\n  }\n  /* .sidebar-scroll::-webkit-scrollbar {\n    width: 8px;\n  } */\n  \n  .sidebar-scroll::-webkit-scrollbar {\n    width: 10px;\n  }\n  \n  .sidebar-scroll::-webkit-scrollbar-track {\n    background: #172639;\n    /* border-left: 1px solid #eaa637; */\n    /* border-radius: 4px; */\n  }\n  \n  .sidebar-scroll::-webkit-scrollbar-thumb {\n    background-color: #eaa637;\n    /* border: 1px solid #ffffff;  */\n    border-radius: 4px;\n  }\n  \n\n.cust-bg {\n   \n    border: none !important;\n    border-radius: 0 !important;\n}\n\n.cust-item {  \n    background-color: var(--secondary-color);\n    color: var(--primary-color); \n    border: none !important;  \n    /* margin: 4px 0px; */\n}\n\n.cust-item a{\n    color: var(--primary-color);\n}\n\n.cust-item.active {\n    /* background-color:var(--primary-color);\n    color: white; */\n    background-color: #f0f0f0;\n    color: var(--secondary-color);\n}\n\n\n.cust-item.active a{\n    /* background-color: var(--primary-color);\n    color: white; */\n    background-color: #f0f0f0;\n    color: var(--secondary-color);\n}\n\n.cust-item:hover {\n    /* background-color: var(--primary-color);\n    color:white; */\n    background-color: #f0f0f0;\n    color: var(--secondary-color);\n}\n\n.cust-item:hover a{\n    /* background-color: var(--primary-color);\n    color:white; */\n    background-color: #f0f0f0;\n    color: var(--secondary-color);\n}\n.sidebar-h2 {\n    /* color: var(--primary-color); */\n    color: #f0f0f0;\n    border-bottom: 1px solid var(--primary-color);\n    font-size: 20px;\n    height: 60px;\n    margin: 0;\n    transition-delay: 0.5s;\n}\n\n\n\n.title-div {\n    height: 60px;\n    border-bottom: 1px solid var(--primary-color);\n   \n}\n\n.bank-sidebar .nav-link {\n   \n    margin-left: 10px;\n}\n\n\n\n\n.nav-item .nav-link {\n    text-align: left;\n    border: none;\n    background: none;\n}\n\n\n\n.top-bar {\n    height: 60px;\n    width: 100%;\n    position: fixed;\n    top: 0;\n    margin-left: 250px;\n}\n.mainn-content {   \n     margin-left: 250px;\n     margin-top: 60px; /* Push content below the Topbar */\n     height: calc(100vh - 60px); /* Full height minus Topbar */\n     overflow-y: auto; /* Enable scrolling for main content */\n     padding: 20px;\n     transition: margin-left 0.3s ease; /* Smooth transition for sidebar collapse */    \n}\n\n\n\n.cust-row {\n    height: 60px;\n}\n\n.top-bar h3 {\n    color: var(--secondary-color);\n    font-weight: bold;\n}\n\n.vr {\n    height: 100%;\n}\n\n.main-content {\n    margin-top: 60px;\n    margin-left: 250px;\n}\n\n\n/* to set setting in the bottom of sidebar */\n.bottom-div {\n    position: absolute;\n    bottom: 0;\n    margin-bottom: 30px;\n}\n\n\n\n.roboto-thin {\n    font-family: \"Roboto\", sans-serif;\n    font-weight: 100;\n    font-style: normal;\n}\n\n.roboto-light {\n    font-family: \"Roboto\", sans-serif;\n    font-weight: 300;\n    font-style: normal;\n}\n\n.roboto-regular {\n    font-family: \"Roboto\", sans-serif;\n    font-weight: 400;\n    font-style: normal;\n}\n\n.roboto-medium {\n    font-family: \"Roboto\", sans-serif;\n    font-weight: 500;\n    font-style: normal;\n}\n\n.roboto-bold {\n    font-family: \"Roboto\", sans-serif;\n    font-weight: 700;\n    font-style: normal;\n}\n\n.roboto-black {\n    font-family: \"Roboto\", sans-serif;\n    font-weight: 900;\n    font-style: normal;\n}\n\n.roboto-thin-italic {\n    font-family: \"Roboto\", sans-serif;\n    font-weight: 100;\n    font-style: italic;\n}\n\n.roboto-light-italic {\n    font-family: \"Roboto\", sans-serif;\n    font-weight: 300;\n    font-style: italic;\n}\n\n.roboto-regular-italic {\n    font-family: \"Roboto\", sans-serif;\n    font-weight: 400;\n    font-style: italic;\n}\n\n.roboto-medium-italic {\n    font-family: \"Roboto\", sans-serif;\n    font-weight: 500;\n    font-style: italic;\n}\n\n.roboto-bold-italic {\n    font-family: \"Roboto\", sans-serif;\n    font-weight: 700;\n    font-style: italic;\n}\n\n.roboto-black-italic {\n    font-family: \"Roboto\", sans-serif;\n    font-weight: 900;\n    font-style: italic;\n}\n\n\n\n.toggle-button {\n    position: absolute;\n    top: 10px;\n    left: 10px;\n    z-index: 1000;    \n    cursor: pointer;\n    background-color: var(--secondary-color);\n    border-radius: 5px;\n    border: none;\n    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2); /* Shadow effect */\n    transition: box-shadow 0.3s ease, transform 0.3s ease;\n  }\n\n  .toggle-button div{\n    width: 20px;\n    height: 2px;\n    /* background-color: var(--primary-color); */\n    background-color: #f0f0f0;\n    margin: 6px 0;\n  }\n\n  .toggle-button:hover {\n     box-shadow: 0px 6px 8px rgba(252, 252, 252, 0.2);\n    transform: translateY(-2px);\n  }\n  \n  .toggle-button:active {\n    box-shadow: 0px 2px 4px rgba(252, 252, 252, 0.2);\n    transform: translateY(1px); \n    \n  }\n\n.sidebar-option{  \n   \n   transition-delay: 0.3;\n}\n\n\n\n  .sideCollapse.sidebar\n  {   \n    width: 60px;\n  }\n  .sideCollapse span.sidebar-option{ \n    width: 0px;\n    display: none;\n\n}\n.sideCollapse.top-bar\n{   \n  margin-left: 60px;\n}\n\n.sideCollapse.mainn-content\n{   \n  margin-left: 60px;\n}\n.cursorPointer{\n    cursor: pointer;\n}\n/* ------------------------------------------media query--------------------------------------------- */\n\n@media screen and (max-width:768px)  \n{\n    \n   \n}\n\n@media screen and (min-width:768px)  \n{\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
